class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    const cartLinkWish = document.querySelector("#wishlist-toggle");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        document.querySelector(".wishlist-link").classList.remove("active");
        document.querySelector(".panier-link").classList.add("active");
        document.querySelector(".card-wishlist ").classList.remove("active");
        document.querySelector(".card-panier").classList.add("active");
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          document.querySelector(".wishlist-link").classList.remove("active");
          document.querySelector(".panier-link").classList.add("active");
          document.querySelector(".card-wishlist ").classList.remove("active");
          document.querySelector(".card-panier").classList.add("active");
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
    if (cartLinkWish) {
      cartLinkWish.setAttribute("role", "button");
      cartLinkWish.setAttribute("aria-haspopup", "dialog");
      cartLinkWish.addEventListener("click", (event) => {
        setTimeout(() => {
          document.querySelector(".card-panier").classList.remove("active");
          document.querySelector(".card-wishlist").classList.add("active");
          document.querySelector(".wishlist-link").classList.add("active");
          document.querySelector(".panier-link").classList.remove("active");
        }, 50);

        event.preventDefault();
        this.open(cartLinkWish);
      });
      cartLinkWish.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          setTimeout(() => {
            document.querySelector(".card-panier").classList.remove("active");
            document.querySelector(".card-wishlist").classList.add("active");
            document.querySelector(".wishlist-link").classList.add("active");
            document.querySelector(".panier-link").classList.remove("active");
          }, 50);

          event.preventDefault();
          this.open(cartLinkWish);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      document.querySelector(".card-panier").classList.add("active");
      document.querySelector(".card-wishlist").classList.remove("active");
      document.querySelector(".wishlist-link").classList.remove("active");
      document.querySelector(".panier-link").classList.add("active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    document.querySelector(".card-panier").classList.remove("active");
    document.querySelector(".card-wishlist").classList.remove("active");
    document.querySelector(".wishlist-link").classList.remove("active");
    document.querySelector(".panier-link").classList.remove("active");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".card-panier",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

document.addEventListener("DOMContentLoaded", () => {
  const headings = document.querySelectorAll(".drawer__heading");

  headings.forEach((heading) => {
    heading.addEventListener("click", (env) => {
      // Remove "active" from all
      headings.forEach((h) => h.classList.remove("active"));

      // Add "active" only to clicked one
      heading.classList.add("active");

      if (heading.classList.contains("wishlist-link")) {
        document.querySelector(".card-wishlist ").classList.add("active");
        document.querySelector(".card-panier").classList.remove("active");
      }

      if (heading.classList.contains("panier-link")) {
        document.querySelector(".card-wishlist ").classList.remove("active");
        document.querySelector(".card-panier").classList.add("active");
      }
    });
  });
});

// Select the element you want to watch
// Robust watcher for .cart-count-bubble text changes
(function () {
  const selector = '.cart-count-bubble span';
  const pollInterval = 250; // ms fallback
  let watcher = { observer: null, pollId: null, last: null, currentEl: null };

  function handleChange(newText) {
    console.log('[cart-watch] changed ->', newText);
    // 👇 put your custom logic here
    // Example: dispatch a custom event people can listen to:
    window.dispatchEvent(new CustomEvent('cartCountChanged', { detail: { value: newText } }));
  }

  function startObserving(el) {
    if (!el) return startWaiting();
    // Disconnect any previous observers/polls
    if (watcher.observer) watcher.observer.disconnect();
    if (watcher.pollId) { clearInterval(watcher.pollId); watcher.pollId = null; }

    watcher.currentEl = el;
    watcher.last = el.textContent.trim();

    // MutationObserver to watch text/node changes inside the element
    watcher.observer = new MutationObserver(() => {
      const txt = el.textContent.trim();
      if (txt !== watcher.last) {
        watcher.last = txt;
        handleChange(txt);
      }
    });
    watcher.observer.observe(el, { characterData: true, childList: true, subtree: true });

    // Parent observer: if element is removed/replaced, reattach
    const parent = el.parentNode;
    if (parent) {
      const parentObs = new MutationObserver(() => {
        if (!document.contains(el)) {
          parentObs.disconnect();
          startWaiting();
        }
      });
      parentObs.observe(parent, { childList: true });
    }

    // Poll fallback (ensures reliability in strange frameworks)
    watcher.pollId = setInterval(() => {
      if (!document.contains(el)) {
        clearInterval(watcher.pollId);
        watcher.pollId = null;
        startWaiting();
        return;
      }
      const txt = el.textContent.trim();
      if (txt !== watcher.last) {
        watcher.last = txt;
        handleChange(txt);
      }
    }, pollInterval);
    document.querySelector('.drawer__heading.panier-link span').textContent = el.textContent;
    console.log('[cart-watch] observing', el, 'initial:', watcher.last);
  }

  function startWaiting() {
    const found = document.querySelector(selector);
    if (found) { startObserving(found); return; }

    // Observe DOM for element being added
    const bodyObs = new MutationObserver((mutations, obs) => {
      const el = document.querySelector(selector);
      if (el) {
        obs.disconnect();
        startObserving(el);
      }
    });
    bodyObs.observe(document.body || document.documentElement, { childList: true, subtree: true });

    // safety: stop trying after 15s
    setTimeout(() => bodyObs.disconnect(), 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWaiting);
  } else startWaiting();

  // Helper to stop watcher if needed
  window.__stopCartWatcher = () => {
    if (watcher.observer) watcher.observer.disconnect();
    if (watcher.pollId) clearInterval(watcher.pollId);
    watcher = { observer: null, pollId: null, last: null, currentEl: null };
    console.log('[cart-watch] stopped');
  };

  // Example listener for the custom event:
  window.addEventListener('cartCountChanged', e => console.log('custom event:', e.detail.value));
})();